var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7659 0H3.23407C1.44798 0 0 1.44791 0 3.23405V20.7658C0 22.552 1.44792 23.9999 3.23407 23.9999H11.8807L11.8954 15.4236H9.66728C9.37772 15.4236 9.1427 15.1895 9.14159 14.8999L9.1309 12.1354C9.12979 11.8443 9.36551 11.6077 9.65666 11.6077H11.8807V8.93651C11.8807 5.83661 13.774 4.14869 16.5393 4.14869H18.8085C19.0988 4.14869 19.3342 4.38406 19.3342 4.67444V7.00547C19.3342 7.29573 19.099 7.53104 18.8088 7.53122L17.4162 7.53187C15.9123 7.53187 15.6211 8.24648 15.6211 9.29522V11.6078H18.9256C19.2405 11.6078 19.4848 11.8827 19.4477 12.1954L19.12 14.9599C19.0887 15.2244 18.8644 15.4237 18.598 15.4237H15.6359L15.6211 24H20.766C22.5521 24 24 22.5521 24 20.766V3.23405C23.9999 1.44791 22.552 0 20.7659 0Z",
    fill: "#475993"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dd2de1cd.svg";
export { ForwardRef as ReactComponent };